import NodeController05ABI from "@abi/NodeController05";
import type { Address } from "viem";
import { useReadContracts } from "wagmi";
import useContract from "./useContract";
import { useERC721Balance } from "./useERC721Balance";

export const useTokenIds = (account: Address) => {
	const { nodeController05Contract } = useContract();
	const balance = useERC721Balance(
		account,
		nodeController05Contract?.address as Address,
	);
	const calls = [...Array.from({ length: balance }).keys()].map((tokenId) => {
		return {
			abi: NodeController05ABI,
			address: nodeController05Contract.address as Address,
			args: [account, BigInt(tokenId?.toString())],
			functionName: "tokenOfOwnerByIndex",
		};
	});
	const { data } = useReadContracts({
		allowFailure: false,
		contracts: calls,
	} as any);

	return data?.map((ress) => (ress ? +ress?.toString() : -1));
};
